import State from 'store/State';
import { Store } from 'redux';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import {
    PositionEntryClearAction,
    positionEntryClearAction,
    PositionEntrySetAction,
    positionEntrySetAction,
} from 'positionEntry/store/actions';

export class PositionEntryBufferService {
    private interval = 300;

    private timerId: NodeJS.Timeout | undefined;
    private pendingPosition: PortfolioPosition | undefined;

    public store?: Store<State>;

    public setPosition(position: PortfolioPosition | undefined) {
        this.pendingPosition = position;
        this.startTimer();
    }

    public clearPosition(clearInput?: boolean) {
        this.clearTimeout();
        this.dispatch(positionEntryClearAction(clearInput));
    }

    private startTimer() {
        // Kill any existing timer and start another one i.e. we dispatch 300ms after the user stops typing...
        this.clearTimeout();
        this.timerId = setTimeout(() => {
            this.dispatchPendingPosition();
            this.clearTimeout();
        }, this.interval);
    }

    private clearTimeout() {
        if (this.timerId) {
            clearTimeout(this.timerId);
        }
        this.timerId = undefined;
    }

    private dispatchPendingPosition() {
        if (this.pendingPosition) {
            this.dispatch(positionEntrySetAction(this.pendingPosition));
            this.pendingPosition = undefined;
        }
    }

    private dispatch(
        action: PositionEntrySetAction | PositionEntryClearAction
    ) {
        if (!this.store) {
            throw new Error('Store must be initialised');
        }
        this.store.dispatch(action);
    }
}
